import { IconProps, iconA11yProps } from '../types';

export const Pause = ({ classNames, label }: IconProps) => (
    <svg className={classNames} id="icon-pause" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 18" {...iconA11yProps(label)}>
        <rect width="3" height="18" rx="1" ry="1" />
        <rect x="7" width="3" height="18" rx="1" ry="1" />
    </svg>
);
